module.exports = __webpack_public_path__ + "img/run_mini.8ec1e323.webp";